const setGraphData_leftsellall = payload => {
  return {
    type: "setGraphData_leftsellall",
    payload
  };
};
export default setGraphData_leftsellall;
